import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import axiosAuth from "../../../axiosAuth";

export interface UpdateCrmResourceManagementPayload {
  crmOpsStatus: "Green" | "Yellow" | "Red";
  comment: string;
  regionHeadId: string;
  relationshipManagerId: string;
}

export interface UpdateCrmResourceManagementResponse {
  data: {
    id: string;
    schoolId: string;
    crmOpsStatus: string;
    comment: string;
    regionHeadId: string;
    relationshipManagerId: string;
    createdAt: string;
    updatedAt: string;
  };
}

const updateCrmResourceManagement = async ({ 
  schoolId, 
  data 
}: { 
  schoolId: string; 
  data: UpdateCrmResourceManagementPayload 
}) => {
  const response = await axiosAuth.put<UpdateCrmResourceManagementResponse>(
    `/v1/school/crm/resource-management/${schoolId}/`,
    data
  );
  return response.data;
};

export const useUpdateCrmResourceManagementMutation = (
  options?: {
    onSuccess?: (data: UpdateCrmResourceManagementResponse) => void;
    onError?: (error: any) => void;
  }
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updateCrmResourceManagement,
    onSuccess: (data) => {
      toast.success("Resource management updated successfully");
      // Invalidate relevant queries
      queryClient.invalidateQueries({ queryKey: ["schools"] });
      queryClient.invalidateQueries({ queryKey: ["crm-resource-management"] });
      options?.onSuccess?.(data);
    },
    onError: (error: any) => {
      const errorMessage = 
        error?.response?.data?.message || 
        error?.response?.data?.issues?.message || 
        "Failed to update resource management";
      toast.error(errorMessage);
      options?.onError?.(error);
    },
  });
};
